import styled from "styled-components";
import TextField from "@material-ui/core/TextField";

export const StyledTextField = styled(TextField)`
  div {
    box-shadow: 1px 2px 0 rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    border: 1px solid #e5e5e5;
    background-color: #ffffff !important;
    height: 50px;
    margin-bottom: 20px;

    input {
      color: #4a4a4a;
      font-family: 'Lato-Semibold';
      font-size: 29px;
      font-weight: normal;
      padding: 7px 12px 3px;
      text-align: right;

      @media only screen and (max-width: 959.95px) {
        font-size: 20px !important;
      }
    }
  }
`;

export const StyledWrapper = styled.div`
  .error-message {
    margin-top: -17px;
    font-size: 13px;
    text-align: right;
    color: red;
  }
`;
